import { combineReducers } from "redux";
import { useReducer } from "./user-redux/userReducer";
import { musicReducer } from "./music-redux/musicReducer";

const appReducer = combineReducers({
  useReducer,
  musicReducer,
});

export default appReducer;
